// extracted by mini-css-extract-plugin
export default {"title":"List-module_title_bDPLE","ul":"List-module_ul_T28oQ","action-1-icon":"List-module_action-1-icon_xUAWV","loading-icon":"List-module_loading-icon_yy2ZW"};